import { IonButton, IonIcon } from "@ionic/react";
import { useGoogleLogin } from "@react-oauth/google";
import { logoGoogle } from "ionicons/icons";

export default function AdminGoogleButton({ isConfigured, onSuccess, onError }) {
  const login = useGoogleLogin({
    scope: "openid email profile",
    onSuccess: (tokenResponse) => onSuccess({ accessToken: tokenResponse.access_token }),
    onError,
  });

  if (!isConfigured) {
    return <div className="oauth-warning">Google OAuth is not configured for this app.</div>;
  }

  return (
    <div className="google-wrap">
      <IonButton expand="block" className="google-login-button" onClick={() => login()}>
        <IonIcon icon={logoGoogle} slot="start" />
        Continue with Google
      </IonButton>
    </div>
  );
}
